<div class="header">
  <button mat-icon-button (click)="closeDialog()" aria-label="Close dialog">
    <mat-icon fontSet="material-icons">cancel</mat-icon>
  </button>
</div>
<h2 mat-dialog-title class="dialog-title">Adicionar novo produto</h2>
<div class="dialog-content">
  <mat-dialog-content>
    @if (!selectedProduct) {
      <div class="search-input-container">
        <mat-form-field>
          <input
            type="text"
            matInput
            placeholder="Pesquisar"
            [(ngModel)]="searchTerm"
            [matAutocomplete]="auto"
            (input)="updateSearchTerm($event)"
            (keydown.enter)="searchProducts()"
            />
            @if (searchTerm) {
              <button
                mat-icon-button
                matSuffix
                (click)="clearInput()"
                >
                <mat-icon fontSet="material-icons">close</mat-icon>
              </button>
            }
            <mat-autocomplete
              #auto="matAutocomplete"
              (optionSelected)="selectProduct($event.option.value)"
              >
              @for (product of products; track product) {
                <mat-option [value]="product">
                  {{ product.codigoProduto.toUpperCase() }} -
                  {{ product.nome.toUpperCase() }}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
          <button
            mat-raised-button
            color="primary"
            (click)="searchProducts()"
            class="search-button"
            >
            Pesquisar
          </button>
        </div>
      }
      <div class="dialog-container">
        @if (selectedProduct) {
          <mat-card class="mb-4">
            <mat-card-content>
              <div class="header-wrapper">
                <mat-card-header class="mat-card-header">
                  <mat-card-title>{{
                    selectedProduct.nome.toUpperCase()
                  }}</mat-card-title>
                  <mat-card-subtitle>
                    Código: {{ selectedProduct.codigoProduto }}
                  </mat-card-subtitle>
                </mat-card-header>
                <span class="clear-choice" (click)="clearInput()"
                  >Limpar escolha</span
                  >
                </div>
                <form #f="ngForm" (ngSubmit)="postFoco()">
                  <mat-form-field
                    class="obj-form-field"
                    appearance="outline"
                    style="height: auto"
                    >
                    <mat-label>Objetivo</mat-label>
                    <input
                      matInput
                      type="text"
                      name="focoInt"
                      [(ngModel)]="focoInt"
                      required
                      pattern="[1-9][0-9]*"
                      (keypress)="numericOnly($event)"
                      (keydown.enter)="postFoco()"
                      />
                      @if (f?.form?.controls?.['focoInt']?.errors?.['required']) {
                        <mat-error
                          >
                          Este campo é obrigatório.
                        </mat-error>
                      }
                      @if (f?.form?.controls?.['focoInt']?.errors?.['pattern']) {
                        <mat-error
                          >
                          Insira um número inteiro maior que zero.
                        </mat-error>
                      }
                    </mat-form-field>
                    @if (selectedProduct) {
                      <button
                        mat-raised-button
                        color="primary"
                        type="submit"
                        [disabled]="!f.valid"
                        style="margin-left: 5px; height: auto"
                        >
                        Adicionar ao Foco
                      </button>
                    }
                  </form>
                  <p style="margin-top: 10px">
                    Valores de vendas e stock de novos produtos adicionados ao foco
                    apenas ficaram visíveis após a atualização diária de dados.
                  </p>
                  @if (!isPortfolio) {
                    <div>
                      <p class="warning">O produto adicionado não faz parte do portfólio Bids Circle.</p>
                      <p class="warning">Utilize esta ferramenta para escoar stock do produto e verifique as alternativas existentes em portfólio da categoria.</p>
                      <p class="warning">Retifique ainda os stocks máximos e mínimos de forma a limitar a necessidade de escoamento no futuro.</p>
                      @if (!alternativesNotFound) {
                        <div>
                          <h4>Produtos Alternativos - Portfólio Bids Circle</h4>
                          <ul>
                            @for (product of alternativeProducts; track product) {
                              <li>
                                {{ product.codigoProduto.toUpperCase() }} -
                                {{ product.nome.toUpperCase() }} - Margem Bruta:
                                {{ product.margemBruta }}€
                              </li>
                            }
                          </ul>
                        </div>
                      }
                    </div>
                  }
                </mat-card-content>
              </mat-card>
            }
            @if (productNotFound) {
              <p>Produto não encontrado.</p>
            }
          </div>
        </mat-dialog-content>
      </div>
